import { Color, TypographyColor } from "../components/typography"
import SvgIcon, { IconName } from "../components/icon/svgIcons"
import Typography, { TypographyElement } from "../RedesignTypography"

import React from "react"
import classNames from "classnames"
import { types } from "react-bricks/frontend"
import { useCheckForEmptyText } from "../../hooks/use-check-for-empty-text"

export interface TestimonialBenefitProps {
    icon: IconName
    text: TypographyElement[]
    index?: number
    color?: TypographyColor
}

const iconOptions: { value: IconName; label: string }[] = [
    { value: "energyTestimonial", label: "Energy" },
    { value: "immuneTestimonial", label: "Immune" },
    { value: "skinTestimonial", label: "Skin" },
    { value: "fitTestimonial", label: "Fit" },
]

const TestimonialBenefit: types.Brick<TestimonialBenefitProps> = ({ icon, text, index, color }) => {
    const emptyText = useCheckForEmptyText(text)

    return (
        <li key={index} className="flex items-center gap-2.5 md:gap-5">
            <span className="flex w-8 shrink-0 justify-end md:w-12">
                <SvgIcon
                    icon={icon}
                    className={classNames("[&_path]:fill-orange", {
                        "w-[21.4px] md:w-[22.5px]": icon === "energyTestimonial",
                        "w-7.5 md:w-[34px]": icon === "immuneTestimonial",
                        "w-[32px] md:w-[35px]": icon === "skinTestimonial",
                        "w-[34px] md:w-[44px]": icon === "fitTestimonial",
                    })}
                />
            </span>
            {!emptyText && (
                <Color color={color}>
                    <Typography
                        propName="text"
                        size="P2"
                        allowList={["bold", "sup", "link"]}
                        className="text-md md:max-w-[157px] lg:max-w-[182px] xl:max-w-[271px]"
                    />
                </Color>
            )}
        </li>
    )
}

TestimonialBenefit.schema = {
    name: "TestimonialBenefit",
    label: "Testimonial Benefit",
    hideFromAddMenu: true,
    sideEditProps: [
        {
            name: "icon",
            label: "Icon",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: iconOptions,
                display: types.OptionsDisplay.Select,
            },
        },
    ],
    getDefaultProps: (): TestimonialBenefitProps => ({
        icon: "energyTestimonial",
        text: [
            {
                type: "paragraph",
                children: [{ text: "lorem ipsum dolor sit amet" }],
            },
        ],
    }),
}

export default TestimonialBenefit
